import React from "react";
import Header from "./Header";
import Sidebar from "./sidebar/Sidebar";
import Footer from "./Footer"

/**
 * Wraps the component by default layout.
 */
export function withMainLayout(Component) {
    return function MainLayoutComponent({ ...props }) {
        return (
            <div className="app-container-v2">
                <div className="sidebar-wrapper-v2">
                    <Sidebar />
                </div>

                <div className="main-content-v2">
                    <Header />
                    <main className="content-body-v2">
                        <Component {...props} />
                    </main>
                    <Footer />
                </div>
            </div>

        )
    }
}
